export { default as DefaultPage } from './DefaultPage';
export { default as MenuPage } from './MenuPage';
export { default as RolePage } from './RolePage';



// WEBPACK FOOTER //
// ./src/features/role/index.js